import * as React from 'react';
import {AnnualPolicyPremiumTypeEnum} from "@falcon/services";
import {getAmountToDisplay} from "../../../../CommonFunctions";
import {StorageSuccessModal} from "../../StorageSuccessModal";

interface IProps {
    factors: any;
    payFullPrice: boolean;
    cardEnding: string;
    renewalPrice: any;
    instalmentsPaidOff: boolean;
    onlyLastInstalmentUnpaid: boolean;
}

export class ChangeAddressStorageSuccessModal extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }

    public render(): React.ReactNode {
        const factors: any = this.props.factors;
        const refund: boolean = factors.returnPremium && factors.returnPremium > 0;
        const payment: boolean = factors.additionalPremium && factors.additionalPremium > 0;

        if (this.props.factors.premiumType === AnnualPolicyPremiumTypeEnum.ANNUAL) {
            return this.renderAnnualModals(factors, refund, payment);
        } else {
            return this.renderMonthlyModals(factors, refund, payment);
        }
    }

    private renderAnnualModals(factors: any, refund: boolean, payment: boolean): React.ReactNode {
        let title: React.ReactNode;
        let content: React.ReactNode;

        if (refund) {
            title = "Your Refund is on the way";
            content =
                <>
                    <p>
                        We’ve saved your changes, and we’ll refund you{' '}
                        <span className="font-weight-bold"> {getAmountToDisplay(factors.returnPremium)}.</span>{' '}
                        Please allow two days for it to arrive.
                    </p>
                    {this.renderNextYearRenewalPrice()}
                </>
        } else if (payment) {
            title = "Payment was successful";
            content =
                <>
                    <p>
                        {getAmountToDisplay(factors.additionalPremium)} has been taken out from your card ending in
                        <span className="font-weight-bold"> {this.props.cardEnding}</span>{' '}
                        to change the address on your home policy.<br/>
                        Please allow a couple of minutes for the payment to be updated in your account.
                    </p>
                    {this.renderNextYearRenewalPrice()}
                </>
        } else {
            title = "All done!";
            content =
                <>
                    <p>
                        We’ve saved your changes, and there’s no extra cost for changing your address.
                    </p>
                    {this.renderNextYearRenewalPrice()}
                </>
        }

        return <StorageSuccessModal title={title} explanationWording={content} />
    }

    private renderMonthlyModals(factors: any, refund: boolean, payment: boolean): React.ReactNode {
        let title: React.ReactNode;
        let content: React.ReactNode;
        if (refund && (!this.props.instalmentsPaidOff && !this.props.onlyLastInstalmentUnpaid)) {
            title = "Your payment plan has been updated";
            content =
                <>
                    <p>
                        <span className="font-weight-bold">{getAmountToDisplay(factors.returnPremium)}</span>{' '}
                        has been reduced from your monthly payments. Your future monthly payments will be
                        <span className="font-weight-bold"> {getAmountToDisplay(factors.monthlyPremium)}</span>
                    </p>
                    {this.renderNextYearRenewalPrice()}
                </>
        } else if (refund && (this.props.instalmentsPaidOff && this.props.onlyLastInstalmentUnpaid)) {
            title = "Your Refund is on the way";
            content =
                <>
                    <p>
                        We’ve saved your changes, and we’ll refund you{' '}
                        <span className="font-weight-bold">{getAmountToDisplay(factors.returnPremium)}.</span>{' '}
                        Please allow two days for it to arrive.
                    </p>
                    {this.renderNextYearRenewalPrice()}
                </>
        } else if (payment && !this.props.payFullPrice) {
            // prototype doesn't have wording about future monthly payments, probably a mistake?
            title = "All done!";
            content =
                <>
                    <p>
                        <span className="font-weight-bold">{getAmountToDisplay(factors.monthlyPaymentSpreadWithInterestAmount || factors.additionalPremium)}</span>{' '}
                        has been added to your monthly payments for changing the address on your home policy.
                    </p>
                    {this.renderNextYearRenewalPrice()}
                </>
        } else if (payment && this.props.payFullPrice) {
            title = "Payment was successful";
            content =
                <>
                    <p>
                        {getAmountToDisplay(factors.additionalPremium)} has been taken out from your card ending in
                        <span className="font-weight-bold"> {this.props.cardEnding}</span>{' '}
                        to change the address on your home policy.<br/>
                        Please allow a couple of minutes for the payment to be updated in your account.
                    </p>
                    {this.renderNextYearRenewalPrice()}
                </>
        } else {
            title = "All done!";
            content =
                <>
                    <p>
                        We’ve saved your changes, and there’s no extra cost for changing your address.
                    </p>
                    {this.renderNextYearRenewalPrice()}
                </>
        }

        return <StorageSuccessModal title={title} explanationWording={content} />
    }

    private renderNextYearRenewalPrice(): React.ReactNode {
        if (this.props.renewalPrice) {
            return (
                <p className="font-weight-bold">
                    Your next year’s renewal price will be {getAmountToDisplay(this.props.renewalPrice)}
                </p>
            )
        } else {
            return <></>
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/modals/annual/home/ChangeAddressStorageSuccessModal.tsx